module.exports = __webpack_public_path__ + "img/accounting.d94ecc8c.svg";